import React, {Component} from 'react';
import UserMenu from "../UserMenu/UserMenu";
import logoPresval from '../../img/layout/LogoMEIPresval_NavTop.svg';

export class Topbar extends Component {

    render() {
        return (
            <div className="layout-topbar clearfix">
                <table width='100%'>
                    <tr>
                        <td width='2%'>
                            <button className="p-link layout-menu-button" onClick={this.props.onToggleMenu}>
                                <span className="pi pi-bars"/>
                            </button>
                        </td>
                        <td width='73%'>
                            <img alt="lightBulb" src={logoPresval} style={{maxWidth: "100%", height: "60px"}}/>
                        </td>
                        <td width='25%' align='right' style={{verticalAlign: "middle"}}>
                            <span>
                                {localStorage.getItem("username")} / {localStorage.getItem("institution")}
                                    &nbsp;&nbsp;&nbsp;
                            </span>
                            <UserMenu history={this.props.history}/>
                        </td>
                    </tr>
                </table>
            </div>
        );
    }
}